import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { NodeFAQ as NodeFaqType } from '../../../types/uncinc_profile/nodes';
import NodeFaqInline from './Inline';
import NodeFaqPage from './Page';

export interface NodeFaqProps {
  entity: ImmutableEntity<NodeFaqType>;
  viewMode?: 'default' | 'inline';
  showLabel?: boolean;
  className?: string;
}

const NodeFaq: React.FC<NodeFaqProps> = ({ viewMode, ...restProps }) => {
  switch (viewMode) {
    case 'inline': {
      return <NodeFaqInline {...restProps} />;
    }

    case 'default':
    default: {
      return <NodeFaqPage {...restProps} />;
    }
  }
};

export default NodeFaq;
